import { get } from 'lodash-es';
import * as operators from './operators.js';
import { QB_GROUP_CONDITION_TYPES } from './types.js';

const resolveCondition = (condition, state, resolveBy = QB_GROUP_CONDITION_TYPES.AND) => {
  if (condition.length === 0 || !condition) return true;
  // resolve by AND: all the conditions must be true
  if (resolveBy) {
    return condition.every((rule) => {
      const { source: sourceRule, operator: operatorRule, value: valueRule } = rule;
      if (typeof operatorRule === 'function') return operatorRule(get(state, sourceRule), valueRule);
      return operators[operatorRule](get(state, sourceRule), valueRule);
    });
  }
  // resolve by OR: at least one condition must be true
  return condition.some((rule) => {
    const { source: sourceRule, operator: operatorRule, value: valueRule } = rule;
    return operators[operatorRule](state[sourceRule], valueRule);
  });
};

export const resolveDependencies = (state, fields) => {
  const fieldsToRender = fields.reduce(
    (result, { target, component, condition, resolveBy, validation, handleWidth }) => {
      if (resolveCondition(condition, state, resolveBy)) result.push({ target, component, validation, handleWidth });
      return result;
    },
    [],
  );
  return fieldsToRender;
};
